import { render, staticRenderFns } from "./RegTan.vue?vue&type=template&id=6ed52549&scoped=true"
import script from "./RegTan.vue?vue&type=script&lang=js"
export * from "./RegTan.vue?vue&type=script&lang=js"
import style0 from "./RegTan.vue?vue&type=style&index=0&id=6ed52549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed52549",
  null
  
)

export default component.exports